<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.4488 8.89L21.3988 4.52C21.1788 3.62 20.3988 3 19.4888 3H5.59883C4.69883 3 3.90883 3.63 3.69883 4.52L2.64883 8.89C2.40883 9.91 2.62883 10.95 3.26883 11.77C3.34883 11.88 3.45883 11.96 3.54883 12.06V19C3.54883 20.1 4.44883 21 5.54883 21H19.5488C20.6488 21 21.5488 20.1 21.5488 19V12.06C21.6388 11.97 21.7488 11.88 21.8288 11.78C22.4688 10.96 22.6988 9.91 22.4488 8.89ZM19.4588 4.99L20.5088 9.36C20.6088 9.78 20.5188 10.2 20.2588 10.53C20.1188 10.71 19.8188 11 19.3188 11C18.7088 11 18.1788 10.51 18.1088 9.86L17.5288 5L19.4588 4.99ZM13.5488 5H15.5088L16.0488 9.52C16.0988 9.91 15.9788 10.3 15.7188 10.59C15.4988 10.85 15.1788 11 14.7688 11C14.0988 11 13.5488 10.41 13.5488 9.69V5ZM9.03883 9.52L9.58883 5H11.5488V9.69C11.5488 10.41 10.9988 11 10.2588 11C9.91883 11 9.60883 10.85 9.36883 10.59C9.11883 10.3 8.99883 9.91 9.03883 9.52ZM4.58883 9.36L5.59883 5H7.56883L6.98883 9.86C6.90883 10.51 6.38883 11 5.77883 11C5.28883 11 4.97884 10.71 4.84883 10.53C4.57884 10.21 4.48883 9.78 4.58883 9.36ZM5.54883 19V12.97C5.62883 12.98 5.69883 13 5.77883 13C6.64883 13 7.43883 12.64 8.01883 12.05C8.61883 12.65 9.41883 13 10.3288 13C11.1988 13 11.9788 12.64 12.5588 12.07C13.1488 12.64 13.9488 13 14.8488 13C15.6888 13 16.4888 12.65 17.0888 12.05C17.6688 12.64 18.4588 13 19.3288 13C19.4088 13 19.4788 12.98 19.5588 12.97V19H5.54883Z"
      class="fill"
    />
  </svg>
</template>

<style lang="scss" scoped>
.fill {
  fill: #666666;
}

.default {
  .fill {
    fill: #417ce9;
  }
}
</style>
